
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/auth";
import Layout from "@/components/Layout";
import ServicePageContainer from "@/components/service/ServicePageContainer";
import { useEffect } from "react";

const ServicePage = () => {
  return (
    <Layout>
      <ServicePageContainer />
    </Layout>
  );
};

export default ServicePage;
